export const TEST_ID = 'supportPage';
